import { render, staticRenderFns } from "./UploadScreen.vue?vue&type=template&id=02a3f35a&"
import script from "./UploadScreen.vue?vue&type=script&lang=js&"
export * from "./UploadScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports